import * as Auth from './Utils/auth';
import * as Metrics from './Utils/metrics';
import * as Messaging from './Utils/messaging';
import * as Notifications from './Utils/notifications';
import * as Support from './Utils/support';
import * as User from './Utils/user';
import * as Vars from './Utils/vars';

export const AdminApi = {
    ...Vars,
    Auth,
    Messaging,
    Metrics,
    Notifications,
    Support,
    User,
}